export default __webpack_public_path__ + "static/media/Solace.063c586f.jpg";